import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class QueryParamService {
    getQuoteId(route: ActivatedRoute): Observable<string> {
        const urlParams = new URLSearchParams(window.location.search);
        const quoteId = this.getRawQueryParam('quoteId') ?? '';

        return new Observable(observer => {
            observer.next(quoteId);
            observer.complete();
        });
    }

    private getRawQueryParam(paramName: string): string | null {
        const regex = new RegExp(`[?&]${paramName}=([^&]*)`);
        const match = window.location.search.match(regex);
        return match ? match[1] : null;
    }
}
